import * as smsReport from '../services/smsReport';

export default {
  namespace: 'smsReport',

  state: {
    // userInfo: null,
    // getMemberList: null,
    // addMember: null,
  },

  effects: {
    // 获取门店树形列表
    *getStoreTreeList({ payload: { values }, callback }, { call, put }) {
      const response = yield call(smsReport.getStoreTreeList, values);
      yield put({
        type: 'save',
        payload: {
          storeTreeList: response.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //短信报表列表
    *getQueryReport({ payload: { values }, callback }, { call, put }) {
      const response = yield call(smsReport.getQueryReport, values);
      yield put({
        type: 'save',
        payload: {
          queryReport: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //短信报表概览
    *getQueryReportSummary({ payload: { values }, callback }, { call, put }) {
      const response = yield call(smsReport.getQueryReportSummary, values);
      yield put({
        type: 'save',
        payload: {
          queryReportSummary: response?.data,
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history }) {
      return history.listen(() => {});
    },
  },
};
